<script lang="ts">
import { browser } from "$app/environment";
	import { getItem, observe, setItem } from "$lib/serv/core/local-store";
	import { map, combineLatestWith, tap, of } from "rxjs";
	import { fly } from "svelte/transition";

	const KEY = 'tracking';
	
	let showTracking = browser ? getItem(KEY) !== 'true' : false;

	function consent() {
		setItem(KEY, 'true');
		showTracking = false;
	}
</script>

{#if showTracking}
	<section class="track-banner" transition:fly={{ y: 20 }}>
		<div><span class="icon-info-20"></span></div>
		<article>
			<p class="body-m book">
				Please note that we utilise user tracking technology to offer you a better user experience, analyse site traffic, and better serve advertising. By continuing to use this website, you consent to our utilising user tracking technology in accordance with our 
				<a href="https://www.mrdfood.com/privacy-policy" target="_blank" style="text-decoration: underline;">Privacy Policy</a>
			</p>
		</article>
		<button class="button secondary medium" on:click={() => consent()}>Got it</button>
	</section>
{/if}

<style lang="scss">
	@use 'color';
	@use 'screen';

	.track-banner {
		position: fixed;
		left: 10px;
		top: 10px;
		z-index: 5;
		width: calc(100vw - 20px);
		background: color.$background-elevation-12dp;
		border-radius: 12px;
		padding: 1rem;
		box-shadow: 0 0 12px rgba(0,0,0,0.1);
		@media(screen.$mdl) {
			display: flex;
			align-items: center;
			left: 50%;
			transform: translateX(-50%);
			top: 6rem;
			width: calc(80vw);
		}
		div {
			min-width: 30px;
			height: 30px;
			border-radius: 50%;
			background: color.$on-background-low-importance;
			display: none;
			justify-content: center;
			align-items: center;
			@media(screen.$mdl) { display: flex; }
			span {
				color: color.$white;
			}
		}
		article	{
			margin: 0 0 1rem 0;
			@media(screen.$mdl) { margin: 0 1.2rem; }
		}
	}
</style>